import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StudentRegistration_stap_1 = ({ register, errors, setValue }) => {
  useEffect(() => {
    setValue("role_id", 4); //  STUDENT ROLE
  }, []);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  // Calculate yesterday's date in YYYY-MM-DD format
  const getYesterdayDate = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1); // Go one day back
    return yesterday.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  };

  return (
    <>
      <h5 className="step-heading">A. Account & Verification</h5>
      <div className="form_holder">
        <div className="row">
          {/* Left Column */}
          <div className="col-md-6">
            <input type="hidden" {...register("role_id")} />
            <Form.Group className="mb-3">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                placeholder="Enter First Name"
                {...register("name", {
                  required: "First Name is required",
                  maxLength: {
                    value: 100,
                    message: "First Name cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.name && (
                <Form.Text className="text-danger">
                  {errors?.name?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                placeholder="Enter Last Name"
                {...register("last_name", {
                  required: "Last Name is required",
                  maxLength: {
                    value: 100,
                    message: "Last Name cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.last_name && (
                <Form.Text className="text-danger">
                  {errors.last_name.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>School Email Address (non-personal)</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter School Email Address"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors?.email && (
                <Form.Text className="text-danger">
                  {errors?.email?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                max={getYesterdayDate()} // ← This prevents selecting today or future dates
                {...register("dob", {
                  required: "Date of Birth is required",
                })}
              />
              {errors?.dob && (
                <Form.Text className="text-danger">
                  {errors.dob.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Right Column */}
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Mobile Phone Number</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter 10-digit Mobile Number"
                maxLength={10}
                {...register("contact_no", {
                  required: "Mobile Phone Number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Please enter a valid 10-digit phone number",
                  },
                })}
                isInvalid={!!errors?.contact_no}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.contact_no?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                  })}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#666",
                    fontSize: "18px",
                    zIndex: 10,
                  }}
                  className="text-muted"
                />
              </div>
              {errors?.password && (
                <Form.Text className="text-danger">
                  {errors.password.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentRegistration_stap_1;
